// Delivery lead-time line on the product page. Listens for the theme's
// VARIANT_CHANGE event and swaps the lead-time text to the selected variant's
// value (from the JSON map rendered by product-lead-time.liquid), falling back
// to the product-level value. Hides the line when the resolved value is empty.
if (!window.DigitalizModules) window.DigitalizModules = {};
if (!window.DigitalizModules.ProductLeadTime) {
  const app = window.Digitaliz;

  class ProductLeadTime {
    constructor(el) {
      this.el = el; // [data-pl-delivery]
      this.textEl = el.querySelector("[data-pl-text]");
      this.map = this._readMap();
      this._onVariantChange = this._onVariantChange.bind(this);
      if (app && this.map) app.on(app.events.VARIANT_CHANGE, this._onVariantChange);
    }

    _readMap() {
      const scope = this.el.closest("form") || document;
      const node = scope.querySelector("[data-pl-lead-times]");
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    _onVariantChange(event) {
      if (!this.textEl) return;
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      const variantLead = this.map.variants && this.map.variants[variant.id];
      const text = variantLead || this.map.fallback || "";

      this.textEl.textContent = text;
      this.el.classList.toggle("is-hidden", String(text).trim() === "");
    }
  }

  window.DigitalizModules.ProductLeadTime = ProductLeadTime;

  function init(root) {
    (root || document).querySelectorAll("[data-pl-delivery]").forEach((el) => {
      if (el.dataset.plBound === "true") return;
      el.dataset.plBound = "true";
      new ProductLeadTime(el);
    });
  }

  init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
}
